import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import difference from 'lodash/difference'
import take from 'lodash/take'
import upperCase from 'lodash/upperCase'

import TooltipA from 'modules/core/components/Tooltip'
import i18n from 'modules/core/lib/i18n'

import {
  UnassignedShiftSummary,
  useCalculateSummaryFromShifts,
} from 'modules/shift_management/hooks/useCalculateSummaryUnassignedShifts'
import { useUnassignedShifts } from 'modules/shift_management/hooks/useUnassignedShifts'

import MoreShiftsTooltip from './MoreShiftsTooltip'
import SummaryTotals from './SummaryTotals'

const CoverageSummary = () => {
  const [unassignedShifts] = useUnassignedShifts()
  const [isTooltipMoreOpen, toggleTooltipMore] = useToggle(false)

  const { summaryFromShifts } = useCalculateSummaryFromShifts({
    unassignedShifts: unassignedShifts,
  })

  const unassignedShiftsSummary = Array.from(summaryFromShifts.values())
  const unassignedShiftsSummarySorted = unassignedShiftsSummary.sort((a, b) =>
    a.title.localeCompare(b.title)
  )

  const moreThanThreeShifts = unassignedShiftsSummarySorted.length > 3

  const unassignedShiftsToDisplay = moreThanThreeShifts
    ? take(unassignedShiftsSummarySorted, 3)
    : unassignedShiftsSummarySorted

  const remainingShifts = difference(unassignedShiftsSummarySorted, unassignedShiftsToDisplay)

  const moreShiftsTooltip = () => <MoreShiftsTooltip unassignedShiftsSummary={remainingShifts} />

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="flexEnd"
      gap="s12"
      width="full"
      paddingX="s8"
    >
      <Box flexDirection="row" alignItems="center" gap="s12" width="full" justifyContent="flexEnd">
        {unassignedShiftsToDisplay.map((unassignedShiftSummary: UnassignedShiftSummary) => (
          <TooltipA.Alt
            key={unassignedShiftSummary.color.toString()}
            attachment="top center"
            label={unassignedShiftSummary.title + ': ' + unassignedShiftSummary.counter}
            textAlign="center"
          >
            <Box
              key={unassignedShiftSummary.color.toString()}
              flexDirection="row"
              gap="s2"
              alignItems="center"
            >
              <Icon.Small icon="circle" color={unassignedShiftSummary.color} />
              <Box maxWidth="s96">
                <Text size="100" weight="bold" color="grey700" ellipsis overflowWrap>
                  {upperCase(unassignedShiftSummary.title)}:
                </Text>
              </Box>
              <Text size="100" weight="bold" color="grey700">
                {unassignedShiftSummary.counter}
              </Text>
            </Box>
          </TooltipA.Alt>
        ))}

        {moreThanThreeShifts && (
          <Tooltip.Dialog
            attachment="top center"
            open={isTooltipMoreOpen}
            toggle={toggleTooltipMore}
            label={moreShiftsTooltip()}
          >
            <Box alignItems="center">
              <Text size="100" weight="bold" color="grey700" ellipsis>
                {upperCase(i18n.t('common.more'))}
              </Text>
            </Box>
          </Tooltip.Dialog>
        )}
      </Box>

      <SummaryTotals />
    </Box>
  )
}

export default CoverageSummary
